import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import {
  formatDate,
  getEndOf2Week,
  getEndOf4Week,
  getEndOfMonth,
  getEndOfWeek,
  getStartOfMonth,
  getStartOfWeek
} from '@shared/timetracking-filter/date.utility';

export enum FilterTypeFields {
  Period = 'period',
  FromDate = 'fromTime',
  ToDate = 'toTime',
  ViewType = 'view'
}

export enum PeriodTypes {
  Day = 'day',
  Week = 'week',
  TwoWeeks = '2weeks',
  FourWeeks = '4weeks',
  Month = 'month'
}

export const PeriodTypesListOptions = [
  {
    value: PeriodTypes.Day,
    label: marker('Day'),
    fromDate: formatDate(),
    toDate: formatDate()
  },
  {
    value: PeriodTypes.Week,
    label: marker('Week'),
    fromDate: getStartOfWeek(),
    toDate: getEndOfWeek()
  },
  {
    value: PeriodTypes.TwoWeeks,
    label: marker('2 Week'),
    fromDate: getStartOfWeek(),
    toDate: getEndOf2Week()
  },
  {
    value: PeriodTypes.FourWeeks,
    label: marker('4 Week'),
    fromDate: getStartOfWeek(),
    toDate: getEndOf4Week()
  },
  {
    value: PeriodTypes.Month,
    label: marker('Month'),
    fromDate: getStartOfMonth(),
    toDate: getEndOfMonth()
  }
];

export type FilterTypes =
  | FilterTypeFields.Period
  | FilterTypeFields.FromDate
  | FilterTypeFields.ToDate
  | FilterTypeFields.ViewType;
